import { Link } from 'react-router';

import Video from '@cartwhl/ui/atoms/Video';
import Text from '@cartwhl/ui/base/Text';
import ChevronLeftIcon from '@cartwhl/ui/icons/ChevronLeftIcon';
import Button from '@cartwhl/ui/input/Button';

import { CDN } from 'consts';

import type { JobMeta } from '../types';
import OpeningList from './OpeningList';
import OpeningsDescription from './OpeningsDescription';

interface JobOpeningLayoutProps {
  meta: JobMeta;
}

export default function JobOpeningLayout({ meta }: JobOpeningLayoutProps) {
  const mailtoLink = `mailto:${meta.applyEmail}?subject=Application for ${meta.title} position`;

  return (
    <main className="container flex flex-col gap-12 py-16">
      <div>
        <Link to="/company">
          <Button variant="tertiary" icon={<ChevronLeftIcon />}>
            Back to careers
          </Button>
        </Link>
      </div>

      <header>
        <Text as="h1" variant="web/display/2xl">
          {meta.title}
          {meta.subtitle && (
            <small className="mt-3 block font-sans text-[24px] leading-none lg:text-[48px]">
              {meta.subtitle}
            </small>
          )}
        </Text>
      </header>

      <section>
        <a
          href={mailtoLink}
          className="font-display text-[20px]/[24px] font-bold leading-tight text-green-50 transition-colors hover:text-[#65F157]"
          target="_blank"
          rel="noopener noreferrer"
        >
          Apply now
        </a>
      </section>

      <OpeningsDescription title="Location" description={meta.location} />

      <OpeningsDescription
        title="About Cartwheel"
        description={meta.aboutCompany}
      />

      <OpeningsDescription title="The Role" description={meta.roleDescription} />

      <hr className="border-gray-30" />

      <section className="flex">
        <div className="grid grid-cols-1 gap-x-10 gap-y-10 md:grid-cols-2">
          <OpeningList title="What You'll Do" items={meta.whatYoullDo} />
          <OpeningList title="Who You Are" items={meta.whoYouAre} />
          <OpeningList title="Why Join Us?" items={meta.whyJoinUs} />
        </div>
      </section>

      <hr className="border-gray-30" />

      <Text as="p" variant="web/body/medium/lg" className="max-w-[956px]">
        {meta.closingComment}
      </Text>

      <a
        href={mailtoLink}
        className="font-display text-[20px]/[24px] font-bold leading-tight text-green-50 transition-colors hover:text-[#65F157]"
        target="_blank"
        rel="noopener noreferrer"
      >
        Apply now
      </a>

      <Video
        className="relative block h-[200px] w-full overflow-hidden md:h-[360px] xl:h-[500px]"
        src={`${CDN}Ambient_Videos_Part1_output.mp4`}
        mode="autoplay"
        contained={true}
      />
    </main>
  );
}
